import _ from 'lodash'

const state = {
  expandedVariants: [],
  displayAllVariantRows: [],
  showAllVariants: false
}

const mutations = {
  update_expanded_variants(state, payload) {
    state.expandedVariants = payload
  },
  update_display_all_variant_rows(state, payload) {
    state.displayAllVariantRows = payload
  },
  update_show_all_variants(state, payload) {
    state.showAllVariants = payload
  }
}

const actions = {
  toggleVariants({ commit, getters, rootGetters }, payload) {
    if(rootGetters['ui/useListView']) {
      const newExpandedVariants = _.xor(getters.expandedVariants, [payload])
      commit('update_expanded_variants', newExpandedVariants)
    } else {
      if(getters.isExpanded(payload)) {
        commit('update_expanded_variants', [])
      } else {
        commit('update_expanded_variants', [])
        commit('update_expanded_variants', [payload])
      }
    }
  },
  openAllVariants({ commit, rootGetters }, payload) {
    if(rootGetters['ui/useListView']) {
      commit('update_expanded_variants', [])
      commit('update_expanded_variants', payload)
    }
  },
  displayAllVariantRows({ commit, getters }, payload) {
    const newDisplayAllVariantRows = _.xor(getters.displayAllVariantRows, [payload])
    commit('update_display_all_variant_rows', newDisplayAllVariantRows)
  },
  toggleShowAllVariants({ commit, getters }, payload) {
    const newVal = _.isUndefined(payload) ? !getters.showAllVariants : payload
    commit('update_show_all_variants', newVal)
  }
}

const getters = {
  expandedVariants: state => state.expandedVariants,
  displayAllVariantRows: state => state.displayAllVariantRows,
  displayAllVariants: state => (id) => _.includes(state.displayAllVariantRows, id),
  isExpanded: state => (id) => _.includes(state.expandedVariants, id),
  showAllVariants: state => state.showAllVariants
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
